import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';

registerLocaleData(localePt, 'pt-BR');
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideLottieOptions } from 'ngx-lottie';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';
import { provideAppConfigInitializer } from './core/config/config.initializer';

/* O Aura vem com a rampa primária no verde esmeralda dele. Sobrescrever as CSS vars
   --p-primary-* no styles.scss não resolvia: o PrimeNG injeta o tema em runtime depois
   da folha de estilo e ganha da nossa regra. Trocar a rampa no próprio preset faz o azul
   da marca valer em todo componente do PrimeNG — botão, input, checkbox, foco. */
const WydoAura = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#EBF3FC',
      100: '#D1E3F8',
      200: '#A3C7F1',
      300: '#75ABE9',
      400: '#4F97E1',
      500: '#378ADD',
      600: '#2872C1',
      700: '#1F5B9C',
      800: '#174475',
      900: '#0F2D4E',
      950: '#08172A',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    // M34: carrega /assets/config.json antes do bootstrap (runtime config + fallback).
    provideAppConfigInitializer(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideBrowserGlobalErrorListeners(),
    // A /oferta é servida como HTML pré-renderizado (ver app.routes.server.ts). A hidratação
    // faz o cliente reaproveitar esse DOM em vez de descartar e repintar a página inteira.
    // Nas demais rotas, que continuam renderizando no cliente, é no-op.
    provideClientHydration(),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
    ),
    provideHttpClient(),
    provideAnimationsAsync(),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    providePrimeNG({
      theme: {
        preset: WydoAura,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
  ],
};
